import React from 'react';
import ko from 'knockout';
import ReactDOM from 'react-dom';

import SectionBase from '../../classes/sectionbase';

import { ProjectsPage } from './ProjectsPage';

export default class OverviewSection extends SectionBase {
  sectionRequiresAuth = true;

  constructor() {
    super();
    ReactDOM.render(
      <ProjectsPage />,
      document.getElementById('sections')
    );
    ko.applyBindings(this);
  }
}
